import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import { getAuthToken } from "../../auth/AuthContext"; // Assume this function retrieves the token without using hooks
     

// Create an Axios instance
const api = axios.create({
    baseURL: 'https://policereports.ci.lubbock.tx.us/api' ,
    headers: {
        "Content-Type": "application/json",
    },
});

// Add a request interceptor to attach the token
api.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
        try {
            const authToken = getAuthToken(); // Retrieve the token without using hooks
            if (authToken) {
                config.headers = config.headers || {};
                config.headers["Authorization"] = `Bearer ${authToken}`;
            }
        } catch (error) {
            console.error("Error fetching token: " + error);
        }
        return config;
    },
    (error: AxiosError) => {
        console.error("Request error: " + error);
        return Promise.reject(error);
    }
);

// Add a response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        const statusCode = error.response?.status;
        if (statusCode && statusCode !== 401) {
            console.error("API Error: " + error);
        }
        if (axios.isAxiosError(error)) {
            console.error('Axios error:', error.message);
            if (error.response) {
                console.error('Response data:', error.response.data);
            }
        } else {
            console.error('Unexpected error:', error);
        }
        return Promise.reject(error);
    }
);


export default api;
